// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__7y3Bp","header":"ReportDetails_header__1aLNS","title":"ReportDetails_title__2sWg0","left":"ReportDetails_left__fx_x6"};